<template>
  <div class="black_bg">
    <div class="box">
      <div class="title">手机号验证<span class="closeBtn" @click="close()"></span></div>
      <div class="wrap">
        <div class="notice">
          请输入手机号（登录软件的账号）验证{{text}}账号状态。
        </div>
        <div class="info"><label>手机号/账号</label><input type="text" v-model="phoneNum"/></div>
        <div class="tips"></div>
        <div style="text-align: center">
          <button  class="btn disable" @click="check()">
            <span style="display: block; position: relative; height: 20px">
              验证
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import Base64 from 'base-64'
export default {
data(){
    return{
        canCheck:true,
        phoneNum:'',
        tip:'',
    }
},
props:{
    src:{
        default:'webtq10',
        type:String,
    },
    text:{
        default:"wh11",
        type:String,
    }
},
methods:{
    close(){
        this.$emit('close',false)
    },
    check(){
        if(!this.canCheck)return
        this.canCheck=false
        axios({
            url:'https://pay.wenhua.com.cn/api/Product/GetWh10IsAccount',
            method:'get',
            params:{
                isclient:false,
                data:this.phoneNum,
                dzh:this.src
            }
        }).then((res)=>{
            this.canCheck=true
            if(res.data.state){
                this.tip = ''
                const data  = btoa(encodeURIComponent(JSON.stringify(res.data)))
                this.$emit('check',data)
            }
            else{
                this.tip = res.data.message
            }
        })
    }
}
};
</script>

<style scoped>
.black_bg {
    position: fixed;
    top:0;
    left:0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 999;
}
.box {
    width: 494px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.title {
    height: 34px;
    background: url(../assets/img/tiao.jpg)no-repeat;
    color: #fafafa;
    font-size: 15px;
    line-height: 34px;
    padding-left: 11px;
}
.closeBtn {
    width: 35px;
    height: 35px;
    position: absolute;
    right: 0;
    top: 0;
    background: url(../assets/img/close.png)no-repeat 50%;
    background-size: 12px;
    cursor: pointer;
}
.wrap {
    background: #fff;
    border: 1px solid #8b8b8b;
    border-top: 0;
    padding: 30px 55px;
    color: #7c7c7c;
    font-weight: bolder;
    font-size: 14px;
}
.notice {
    background: none;
    min-height: 16px;
    font-size: 14px;
    color: #666;
    padding-left: 0;
    margin-bottom: 15px;
}
.info {
    margin-bottom: 10px;
    padding-left: 50px;
}
label {
    width: auto;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
}
input, select {
    height: 32px;
    border: 1px solid #d4d4d4;
    width: 60%;
    background-color: #fff;
    padding: 0 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
}
.tips{
    padding-left: 50px;
    min-height: 16px;
    color: #dc143c;
    font-size: 12px;
}
.btn {
    color: #fff;
    font-weight: bolder;
    background: #4984d4;
    padding: 5px 28px;
    cursor: pointer;
    display: inline-block;
    zoom: 1;
    border: 0;
    outline: 0;
    margin: 25px 10px 0;
}
</style>